"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheGlobalSubjectEnum = void 0;
var CacheGlobalSubjectEnum;
(function (CacheGlobalSubjectEnum) {
    CacheGlobalSubjectEnum["OAUTH_RESPONSE"] = "OAUTH_RESPONSE";
})(CacheGlobalSubjectEnum = exports.CacheGlobalSubjectEnum || (exports.CacheGlobalSubjectEnum = {}));
